import Timestamp from "components/Timestamp";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ApiKey } from "types/generated";

const PersonalApiKeysTableExpiresAtCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<Pick<ApiKey, "expiresAt">>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {apiKey.expiresAt && <Timestamp variant="p-body3" timestamp={apiKey.expiresAt} />}
      {!apiKey.expiresAt && <TableCellText>Never expires</TableCellText>}
    </TableSimpleCell>
  );
};

export default PersonalApiKeysTableExpiresAtCell;
